import type { CarbonCompensation } from "@/mocks/carbono";
import CarbonStatusBadge from "./CarbonStatusBadge";

interface CompensationTableProps {
  compensations: CarbonCompensation[];
}

export default function CompensationTable({ compensations }: CompensationTableProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200">
              <th className="text-left px-4 py-3 font-semibold text-foreground-700">Projeto</th>
              <th className="text-left px-4 py-3 font-semibold text-foreground-700">Área</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">Mudas previstas</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">Plantadas</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">Sobrevivência</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">Vistorias</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">CO2e preliminar</th>
              <th className="text-left px-4 py-3 font-semibold text-foreground-700">Status</th>
              <th className="text-right px-4 py-3 font-semibold text-foreground-700">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-background-100">
            {compensations.map((comp) => (
              <tr key={comp.id} className="hover:bg-background-50/50 transition-colors">
                <td className="px-4 py-3">
                  <div className="font-medium text-foreground-800">{comp.projectName}</div>
                  <div className="text-foreground-400 text-[11px]">{comp.obligationType}</div>
                </td>
                <td className="px-4 py-3 text-foreground-700">{comp.areaName}</td>
                <td className="px-4 py-3 text-right font-medium text-foreground-800">{comp.seedlingsPlanned.toLocaleString("pt-BR")}</td>
                <td className="px-4 py-3 text-right font-medium text-foreground-800">{comp.seedlingsPlanted.toLocaleString("pt-BR")}</td>
                <td className="px-4 py-3 text-right">
                  <span className={`font-semibold ${comp.survivalRate >= 80 ? "text-primary-700" : comp.survivalRate >= 60 ? "text-caution-700" : "text-warning-700"}`}>
                    {comp.survivalRate}%
                  </span>
                </td>
                <td className="px-4 py-3 text-right text-foreground-700">{comp.inspectionsDone}</td>
                <td className="px-4 py-3 text-right font-medium text-primary-700">{comp.co2ePreliminary.toLocaleString("pt-BR", { maximumFractionDigits: 1 })} t</td>
                <td className="px-4 py-3">
                  <CarbonStatusBadge status={comp.status} type="compensation" />
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-1">
                    <button className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center transition-colors" title="Abrir">
                      <i className="ri-eye-line w-full h-full flex items-center justify-center text-foreground-500" />
                    </button>
                    <button className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center transition-colors" title="Relatório">
                      <i className="ri-file-chart-line w-full h-full flex items-center justify-center text-foreground-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}